import * as Yup from "yup";

export const supplierSchema = Yup.object().shape({
  id: Yup.string().optional(),
  name: Yup.string()
    .required("O nome é obrigatório")
    .min(3, "O nome deve ter pelo menos 3 caracteres"),
  phone: Yup.string().required("O telefone é obrigatório"),
  //.matches(/^\(\d{2}\) \d{5}-\d{4}$/, 'O telefone deve estar no formato (XX) XXXXX-XXXX'),
  address: Yup.string().optional(),
  key_type: Yup.string().nullable(),
  pix_key: Yup.string().nullable(),
  slug: Yup.string().optional(),
});
